<section class="jumbotron">
  <header class="jumbotron__header">
    <div class="jumbotron__header__container left">
      <h1 class="display jumbotron__header__container__title">{{ 'company.name' | translate }}</h1>
      <h2 class="heading jumbotron__header__container__subtitle">{{ 'homePage.seo.title' | translate }}</h2>
      <p class="jumbotron__header__container__text">{{ 'homePage.seo.description' | translate }}</p>
      <div class="jumbotron__header__container__buttons">
        <ng-container *ngFor="let cta of 'homePage.jumbotron.ctas' | translate">
          <a
            *ngIf="isFragment(cta.href); else strokedBtnTpl"
            placeme-stroked-button
            [routerLink]="['/'] | localize"
            [fragment]="cta.href.substring(1)"
          >
            {{ cta.label }}
          </a>
          <ng-template #strokedBtnTpl>
            <a placeme-button [href]="cta.href">
              {{ cta.label }}
            </a>
          </ng-template>
        </ng-container>
      </div>
    </div>
    <div class="jumbotron__header__container right">
      <placeme-animate-profile></placeme-animate-profile>
    </div>
  </header>
  <div class="jumbotron__scroll">
    <a class="jumbotron__scroll_button breathing-2s" placeme-fab-stroked-button [routerLink]="['/'] | localize" fragment="video">
      <fa-icon [icon]="faChevronDown"></fa-icon>
    </a>
  </div>
</section>
